import { getCityFromLocale, getGoogleMapLanguageFromLocale } from '@repo/utils'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CarbonFootprintMealTypeFieldProps } from '../CarbonFootprintForm'
import { useLocale } from '../../../../../hooks/use-locale'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../shadcn/components/ui/form'
import GeolocalisationField from '../../../../atoms/fields/geolocalisation-field/GeolocalisationField'
import { GEOGRAPHICAL_SEARCH_BOUNDS } from '../../../location-picker/GEOGRAPHICAL_SEARCH_BOUNDS'

const CarbonFootprintDepartureCityField = ({
  form,
  houseLocation,
}: CarbonFootprintMealTypeFieldProps & {
  houseLocation?: google.maps.LatLngLiteral
}) => {
  const { locale } = useLocale()
  const intl = useIntl()
  return (
    <FormField
      control={form.control}
      name='departureCity'
      render={() => (
        <FormItem>
          <FormLabel className='font-normal'>
            <FormattedMessage
              id='ui.CarbonFootpringForm.departureCity.label'
              defaultMessage='Ville de départ'
            />
          </FormLabel>
          <FormControl>
            <GeolocalisationField
              form={form}
              name='departureCity'
              placeholder={intl.formatMessage({
                id: 'ui.CarbonFootpringForm.departureCity.placeholderId',
                defaultMessage: 'Entrez le nom de la ville',
              })}
              getPlacePredictionsProps={{
                language: getGoogleMapLanguageFromLocale(locale),
                locationRestriction: GEOGRAPHICAL_SEARCH_BOUNDS,
                origin: houseLocation || getCityFromLocale(locale),
                types: ['(cities)'],
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      rules={{ required: true }}
    />
  )
}

export default CarbonFootprintDepartureCityField
